export enum AttributeTypes {
    String = 'string',
    Number = 'number',
    Date = 'date',
    DateTime = 'dateTime',
    Time = 'time',
    Reference = 'reference'
}
